import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import { getSummaryList, startSummary, endSummary } from '@/api/modules/summary';
import dayjs from "dayjs";
export default {
  name: "base-summary",
  data: function data() {
    return {
      dayjs: dayjs,
      searchForm: {
        pn: 1,
        ps: 20
      },
      tableLoading: false,
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this.tableLoading = true;
              _context.p = 1;
              _context.n = 2;
              return getSummaryList(_this.searchForm);
            case 2:
              res = _context.v;
              console.log(res);
              // res.data.forEach((item) => {
              //     item.start_time = item.start_time ? dayjs(item.start_time * 1000).format(
              //         "HH:mm:ss"
              //     ) : "";
              //     item.end_time = item.end_time ? dayjs(item.end_time * 1000).format(
              //         "HH:mm:ss"
              //     ) : "";
              // });
              _this.tableData = res.data;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              _context.p = 4;
              _this.tableLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    },
    handleStart: function handleStart(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return startSummary({
                id: row.id
              });
            case 1:
              _this2.$message.success('操作成功');
              _this2.getData();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }))();
    },
    handleEnd: function handleEnd(row, type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return endSummary({
                id: row.id,
                type: type // 1: 讨论, 2: 结束
              });
            case 1:
              _this3.$message.success('操作成功');
              _this3.getData();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    formatDuration: function formatDuration(seconds) {
      var minutes = Math.floor(seconds / 60);
      var remainingSeconds = seconds % 60;
      return "".concat(String(minutes).padStart(2, '0'), ":").concat(String(remainingSeconds).padStart(2, '0'));
    }
  }
};